import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getCheckpointByUUIDService = async (checkpoint_uuid) => {
  const site_uuid = JSON.parse(localStorage.getItem("device"))[1];
  const { data } = await supabase
    .from("site_patrol_checkpoint")
    .select()
    .eq("site_uuid", site_uuid);
  return await data;
};

export const getCheckpointByCheckpointService = async (checkpoint_uuid) => {
  try {
    const site_uuid = JSON.parse(localStorage.getItem("device"))[1];
    const { data, error } = await supabase
      .from("site_patrol_checkpoint")
      .select()
      .eq("checkpoint_uuid", checkpoint_uuid)
      .eq("site_uuid", site_uuid);
    
    if (error) {
      throw new Error(`Supabase error: ${error.message}`);
    }
    
    return data[0];
  } catch (error) {
    console.error("Error in getCheckpointByCheckpointService:", error);
    throw error; // Re-throw to be handled by the calling component
  }
};
